var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import isEqual from "react-fast-compare";
import { checkKey, filterChildrenOfType } from "../../utils/Functions";
import { BaseInput } from "./BaseInput";
import { Option } from "./Option";
var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio(props) {
        var _this = _super.call(this, props) || this;
        _this.inputs = {};
        _this.getPropertyName = function () { return "checked"; };
        _this.getEventType = function () { return "click"; };
        _this.componentDidUpdate = function (prevProps) {
            if (!isEqual(prevProps.defaultValue, _this.props.defaultValue) && _this.checkValueValidity(_this.props.defaultValue)) {
                var index = filterChildrenOfType(_this, Option).map(function (c, i) { return ({ c: c, i: i }); }).find(function (cc) { return isEqual(cc.c.props.value, _this.props.defaultValue); }).i;
                _this.dispatchValue(true, _this.inputs[index]);
            }
        };
        _this.checkValueValidity = function (value) {
            var children = filterChildrenOfType(_this, Option);
            return children.some(function (c) { return isEqual(c.props.value, value); });
        };
        _this.onChange = function (value, e) {
            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange;
            if (disabled)
                return;
            _this.setState({ value: value }, function () {
                if (onChange)
                    onChange(value, e);
            });
        };
        _this.checkSpace = function (index, e) {
            var disabled = _this.props.disabled;
            checkKey(e, function () { return _this.dispatchValue(true, _this.inputs[index]); }, disabled, ["Space"]);
        };
        _this.render = function () {
            var _a = _this.props, className = _a.className, style = _a.style, disabled = _a.disabled, onBlur = _a.onBlur, onFocus = _a.onFocus, required = _a.required, controlName = _a.controlName, children = filterChildrenOfType(_this, Option), value = _this.state.value;
            return React.createElement("div", { className: "dolfo-control radio" },
                _this.getLabel(),
                children.map(function (c, i) {
                    var _a = c.props, optValue = _a.value, optDisabled = _a.disabled, option = new Option(__assign(__assign({}, c.props), { disabled: disabled || optDisabled })), selected = isEqual(value, optValue);
                    return React.createElement(React.Fragment, { key: i },
                        option.renderOption({
                            type: "radio",
                            style: style,
                            className: className,
                            selected: selected,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            onClick: function () { return _this.dispatchValue(true, _this.inputs[i]); },
                            onKey: function (e) { return _this.checkSpace(i, e); }
                        }),
                        React.createElement("input", { type: "radio", value: optValue === null ? undefined : optValue, onChange: function (e) { return _this.onChange(optValue, e); }, disabled: disabled || optDisabled, ref: function (r) {
                                _this.inputs[i] = r;
                            }, name: controlName, checked: selected, required: required }));
                }));
        };
        _this.state = __assign(__assign({}, _this.state), { value: _this.checkValueValidity(props.defaultValue) ? props.defaultValue : null });
        return _this;
    }
    return Radio;
}(BaseInput));
export { Radio };
